
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7a2d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7a2d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $800sp = parcelRequire("800sp");

var $gKeLP = parcelRequire("gKeLP");

var $gngdn = parcelRequire("gngdn");

var $lHTSI = parcelRequire("lHTSI");
parcelRequire("iqDfP");
parcelRequire("jCB6t");
parcelRequire("5GLzX");

var $baa6D = parcelRequire("baa6D");
// Make sure dayJS can parse different kind of date formats
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($lHTSI))));
function $3e4abf7e13ebd52a$export$3c2ab2c4f3202ceb(text) {
    const formats = [
        "DD/MM",
        "DD/MM/YY",
        "DD/MM/YYYY",
        "DD-MMM-YYYY",
        "DD MMM",
        "hh:mm A",
        "hh:mm"
    ];
    let d = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(text, formats, true);
    if (d.isValid()) {
        if (d.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(), "day")) // If it's in the future, subtract one year.
        d = d.subtract(1, "year");
        return d.format("DD/MM/YYYY");
    }
    return text;
}
class $3e4abf7e13ebd52a$var$ConvertPage extends (0, $800sp.LitElement) {
    createRenderRoot() {
        return this; // Disable Shadow DOM
    }
    static properties = {
        selectedBank: {
            type: String,
            state: true
        },
        progressMessage: {
            type: String,
            state: true
        },
        errorMessage: {
            type: String,
            state: true
        }
    };
    constructor(){
        super();
    }
    render() {
        return (0, $800sp.html)`
      <bank-select @bank-selected=${this._handleBankSelected}></bank-select>
      ${this.selectedBank ? (0, $800sp.html)`<file-input @file-confirmed=${this._handleFileConfirmed}></file-input>` : ""}
      <info-box type='error' message=${this.errorMessage}></info-box>
      <info-box type='normal' message=${this.progressMessage}></info-box>
    `;
    }
    _handleBankSelected(event) {
        this.selectedBank = event.detail.bank;
        console.debug("selectedBank", this.selectedBank);
    }
    _handleFileConfirmed(event) {
        const file = event.detail.file;
        console.debug("processing file", file);
        this.progressMessage = "Start processing ${file.name}";
        const reader = new FileReader();
        reader.onload = ()=>{
            this._convertToCSV(reader.result, file.name, this.selectedBank).then(()=>{
                // Indicate success for this file
                console.log(`File ${file.name} processed successfully`);
                this.progressMessage = `File ${file.name} processed successfully`;
            }).catch((error)=>{
                // Handle errors gracefully
                console.error(`Error processing ${file.name}:`, error);
                this.errorMessage = `Error processing ${file.name}: ${error}`;
            });
        };
        reader.readAsArrayBuffer(file);
    }
    _rowsToCSV(data) {
        // 1. Gather all unique keys
        const allKeys = new Set();
        for (const row of data)for (const key of Object.keys(row))allKeys.add(key);
        // 2. Create custom header
        const headerRow = {};
        for (const key of allKeys){
            let display = key;
            if (key == "minus") display = "withdrawal";
            if (key == "plus") display = "deposit";
            headerRow[key] = display;
        }
        const dataWithHeader = [
            headerRow,
            ...data
        ];
        const csvData = (0, (/*@__PURE__*/$parcel$interopDefault($gKeLP))).unparse(dataWithHeader, {
            header: false,
            delimiter: ",",
            escapeChar: '"',
            quotes: true // Always quote fields 
        });
        return csvData;
    }
    _downloadCSV(csvContent, filename) {
        const blob = new Blob([
            csvContent
        ], {
            type: "text/csv;charset=utf-8;"
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = filename || "download.csv"; // Use a default filename, if needed
        link.click();
        URL.revokeObjectURL(url); // Clean up
    }
    async _convertToCSV(arrayBuffer, filename, selectedBank) {
        const loadingTask = (0, $baa6D.getDocument)(arrayBuffer);
        const pdf = await loadingTask.promise;
        const numPages = pdf.numPages;
        const batchSize = 3;
        try {
            const allData = {};
            const allRows = [];
            let indexOffset = 0;
            let previousLastRow;
            for(let pageNo = 1; pageNo <= numPages;){
                const batches = [];
                for(let i = 0; i < batchSize && pageNo <= numPages; i++, pageNo++){
                    const page = await pdf.getPage(pageNo);
                    const pageTextContent = await page.getTextContent();
                    const tokens = [];
                    let index = 0;
                    for (const content of pageTextContent.items){
                        const [scaleX, bobo, dada, scaleY, tx, ty] = content.transform;
                        if (content.str.trim() === "") continue;
                        const indexInAll = index + indexOffset;
                        index += 1;
                        const token = (0, $baa6D.generateToken)(indexInAll, content);
                        allData[indexInAll] = token.storedText;
                        tokens.push(token.token);
                    }
                    batches.push({
                        pageNo: pageNo,
                        tokens: tokens
                    });
                    indexOffset += tokens.length;
                }
                // Serialize and send to API using fetch (for example)
                const jsonData = JSON.stringify({
                    batches: batches,
                    previousLastRow: previousLastRow
                });
                console.debug("data: ", jsonData);
                const apiResponse = await fetch(`convert/${selectedBank.toLowerCase()}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: jsonData
                });
                if (!apiResponse.ok) throw new Error(`API request failed with status ${apiResponse.status}`);
                const rows = await apiResponse.json(); // Assuming API returns an array of strings
                if (rows) {
                    console.debug("rows ", rows);
                    // Remove the last row from previous data.
                    if (allRows.length > 0) allRows.pop();
                    // Record the last row, this will pass into the next API call
                    // When the next API return, this row will always be the head
                    // Hence we remove the last row from previous data.
                    previousLastRow = rows[rows.length - 1];
                    allRows.push(...rows.map((row)=>{
                        const originalEntries = Object.fromEntries(Object.entries(row).map(([key, value])=>{
                            if (Array.isArray(value)) {
                                // Process if value is an array
                                const processedArray = value.map((item)=>allData[item] || item).join("\n");
                                return [
                                    key,
                                    processedArray
                                ];
                            } else // Original handling for non-array values
                            return [
                                key,
                                allData[value] || value
                            ];
                        }));
                        originalEntries["date"] = $3e4abf7e13ebd52a$export$3c2ab2c4f3202ceb(originalEntries["date"]);
                        const descriptions = originalEntries["descriptions"];
                        const refs = originalEntries["refs"];
                        const joinedString = descriptions + (refs ? `\n${refs}` : "");
                        // console.debug('joinedString ', joinedString);
                        const serialFromDescriptions = (0, $baa6D.splitDescription)(joinedString, "description");
                        // console.debug('serialFromDescriptions ', serialFromDescriptions);
                        return {
                            ...originalEntries,
                            ...serialFromDescriptions
                        };
                    }));
                }
            }
            const csv = this._rowsToCSV(allRows);
            // textContentDiv.textContent = csv;
            this._downloadCSV(csv, `${filename}.csv`);
        } catch (error) {
            console.error("Error processing text content:", error);
            throw error;
        }
    }
}
customElements.define("convert-page", $3e4abf7e13ebd52a$var$ConvertPage);


//# sourceMappingURL=index.6718e2c9.js.map
